<template>
  <v-dialog
      v-model="show"
      persistent
      width="400"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Изменить пароль</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
                label="Старый пароль*"
                v-model="old_password"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                @click:append="show_password = !show_password"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
                label="Новый пароль*"
                v-model="password"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                @click:append="show_password = !show_password"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
                label="Повторите пароль*"
                v-model="password_confirmation"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                @click:append="show_password = !show_password"
                required
            ></v-text-field>
          </v-col>

        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue-darken-1"
            variant="text"
            @click="show = false"
        >
          Отменить
        </v-btn>
        <v-btn
            color="blue-darken-1"
            variant="text"
            @click="update"
        >
          Обновить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ChangePasswordDialog",
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      old_password: null,
      password: null,
      password_confirmation: null,
      show_password: false,
    }
  },

  watch: {
    show(val) {
      if (!val) {
        this.clear();
      }
    },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },

      set(show) {
        this.$emit('input', show);
      }
    },

    payload() {
      return {
        old_password: this.old_password,
        password: this.password,
        password_confirmation: this.password_confirmation,
      }
    },
  },

  methods: {
    ...mapActions({
      updatePassword: 'user/updatePassword',
    }),

    clear() {
      this.old_password = null;
      this.password = null;
      this.password_confirmation = null;
    },

    update() {
      this.updatePassword(this.payload)
          .then(() => {
            this.show = false;
          });
    },
  },
}
</script>

<style scoped>

</style>